<template>
  <div>
    <v-carousel
      v-if="$vuetify.theme.dark == true"
      hide-delimiters
      :show-arrows="false"
      v-model="modelo"
    >
      <v-carousel-item v-for="(item, index) in items" :key="index">
        <v-list-item
          style="background-color: rgb(39, 39, 39)"
          :to="{
            path: link,
            query: { item: items[modelo].images, num, description }
          }"
        >
          <v-list-item-content class="mt-10">
            <v-img
              class="image"
              @click="
                num = i;
                description = items[modelo].description;
              "
              v-for="(itemImage, i) in image"
              :key="i"
              :src="require(`../../../../styles/${items[modelo].images[i]}`)"
            ></v-img>
          </v-list-item-content>
        </v-list-item>
      </v-carousel-item>
    </v-carousel>
    <v-carousel v-else hide-delimiters :show-arrows="false" v-model="modelo">
      <v-carousel-item v-for="(item, index) in items" :key="index">
        <v-list-item
          style="background-color: #F2F2F2"
          :to="{
            path: link,
            query: { item: items[modelo].images, num, description }
          }"
        >
          <v-list-item-content class="mt-10">
            <v-img
              class="image"
              @click="
                num = i;
                description = items[modelo].description;
              "
              v-for="(itemImage, i) in image"
              :key="i"
              :src="require(`../../../../styles/${items[modelo].images[i]}`)"
            ></v-img>
          </v-list-item-content>
        </v-list-item>
      </v-carousel-item>
    </v-carousel>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true
    },
    image: {
      type: Number,
      required: true
    },
    modelo: {
      type: Number,
      required: true
    },
    link: {
      type: String,
      required: true
    }
  },
  model: 0,
  data() {
    return {
      num: 0,
      description: ""
    };
  }
};
</script>

<style scoped>
@media only screen and (max-width: 836px) {
  .image {
    height: 100px;
    max-width: 100px;
    margin: 1px;
  }
}
@media only screen and (min-width: 837px) {
  .image {
    height: 200px;
    max-width: 200px;
    margin: 10px;
  }
}
@media only screen and (max-width: 1205px) and (min-width: 500px) {
  .image {
    height: 150px;
    max-width: 150px;
    margin: 5px;
  }
}
@media only screen and (max-width: 865px) and (min-width: 837px) {
  .image {
    height: 125px;
    max-width: 125px;
    margin: 1px;
  }
}
</style>
